import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import "./DataSourceDonut.css";

// Register chart components
ChartJS.register(ArcElement, Tooltip, Legend);

const centerTextPlugin = {
  id: "centerText",
  beforeDraw(chart) {
    const { width, height, ctx } = chart;
    ctx.save();

    const centerX = width / 2;
    const centerY = height / 2;

    // "Total" label
    ctx.font = "400 13px Inter, sans-serif";
    ctx.fillStyle = "#94a3b8";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("Total", centerX, centerY - 14);

    // "100%" value
    ctx.font = "700 24px Inter, sans-serif";
    ctx.fillStyle = "#1e293b";
    ctx.fillText("100%", centerX, centerY + 14);

    ctx.restore();
  },
};

export default function DataSourceDonut({ dataSourceData }) {
  const total = dataSourceData.reduce((sum, d) => sum + d.value, 0);
  const chartData = {
    labels: dataSourceData.map((d) => d.name),
    datasets: [
      {
        data: dataSourceData.map((d) => d.value),
        backgroundColor: dataSourceData.map((d) => d.color),
        borderWidth: 0, // removes the white segment borders
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "63%",
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            const val = context.parsed;
            const pct = Math.round((val / total) * 100);
            return ` ${context.label}: ${pct}%`;
          },
        },
      },
    },
  };

  return (
    <div className="donut-container">
      <div style={{ width: "100%", height: "200px" }}>
        <Doughnut data={chartData} options={chartOptions} plugins={[centerTextPlugin]} />
      </div>
      <ul className="custom-legend">
        {dataSourceData.map((item, index) => (
          <li key={index}>
            <span className="legend-color" style={{ backgroundColor: item.color }} />
            <span className="legend-name">{item.name}</span>
            <span className="legend-pct">{item.value}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
